<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="thirdAccountSelected"
    :clearable="!unclearable"
    :items="suppliersItems"
    :loading="thirdAccountLoading"
    :search-input.sync="thirdAccountSearch"
    item-text="Description"
    item-value="id"
    :label="noLabel ? '' : type == 104 ? $t('LakalaAccount.ObjectName') : $t('HuifuAccount.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import ThirdAccountInfo from "@/api/third-account-info"


export default {
  name: "SearcherThirdAccount",

  props: {
    value: Number,
    noLabel: Boolean,
    dense: Boolean,
    type: String,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    suppliersItems() {
      return this.thirdAccount.map((thirdAccount) => {
        let Description = ''
        if (this.type == 104) {
          Description = thirdAccount.lakala_out_member_no + " / " + thirdAccount.company_name;
        } else {
          Description = thirdAccount.huifu_id + " / " + thirdAccount.short_name;
        }
        return Object.assign({}, thirdAccount, { Description });
      });
    },
  },

  data: () => ({
    thirdAccount: [],
    thirdAccountLoading: false,
    thirdAccountSearch: "",
    thirdAccountSelected: null,
  }),

  mounted() {
    this.getThirdAccountFromAPI();
  },

  methods: {
    getThirdAccountFromAPI() {
      this.thirdAccountLoading = true;
      if (this.type == 104) {
        ThirdAccountInfo.indexAllForLkl({pay_type: this.type})
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.thirdAccount = response.data.third_account;
              }
              this.thirdAccountLoading = false;
            }.bind(this)
          ).catch(
            function () {
              this.thirdAccountLoading = false;
            }.bind(this)
        );
      } else {
        ThirdAccountInfo.fetchAll({pay_type: this.type})
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.thirdAccount = response.data.third_account;
              }
              this.thirdAccountLoading = false;
            }.bind(this)
          ).catch(
            function () {
              this.thirdAccountLoading = false;
            }.bind(this)
        );
      }

    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.thirdAccountSelected = this.value;
      },
    },
    thirdAccountSelected: {
      handler() {
        if (this.thirdAccountSelected == null) {
          this.$emit("input", 0);
          this.$emit("change");
        }
        if (this.thirdAccountSelected && this.thirdAccountSelected.id ) {
          this.$emit("input", this.thirdAccountSelected.id);
          this.$emit("change");
        }
      },
    },
  },
};
</script>
